export enum APIResponseStatusType {
  SUCCESS = 'success',
  FAIL = 'fail',
  ERROR = 'error',
  UNAUTHORIZED = 'Unauthorized.',
  TIMEOUT = 'service unavailable',
  NO_RPU = 'RPU does not exist',
  RPU_UNAVAILABLE = 'RPU unavailable',
  UNREGISTERED_EMAIL = 'unregistered email',
  NO_CREDENTIALS = 'Could not fetch account credentials',
  NO_EXECUTIONS_REMAINING = 'no executions remaining',
  NETWORK_ERROR = 'Error Network Error',
}
